



































import { Vue, Component, Prop } from 'vue-property-decorator';
import EmployeeSummary from '@/domain/schedule/employee/employee-summary.entity';
import EmployeeService from '@/domain/employees/service/employee.service';
import SelectionComponent from '@/shared/fields/selection.componet.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import debounce from '@/shared/utils/debounce';

@Component({
  components: {
    SelectionComponent,
    LabelSlot,
  },
})
export default class ManagerFilter extends Vue {
  @Prop({
    type: String,
    default: 'Gestor',
  }) label!: string;

  @Prop({
    type: String,
    default: 'Digite o nome...',
  }) placeholder!: string;

  @Prop({
    type: String,
    default: 'Nenhum gestor encontrado...',
  }) noDataText!: string;

  managersSelected: string[] = [];

  foundManagers: EmployeeSummary[] = [];

  managerName: string = '';

  loading: boolean = false;

  lastFilterManager: string = '';

  selected() {
    this.$emit('selected', this.managersSelected);
  }

  findManagersDebounce(value: string) {
    debounce.debounce(() => this.findManagers(value));
  }

  findManagers(value: string) {
    if ((this.lastFilterManager !== value) && value) {
      this.lastFilterManager = value;
      if (value.length > 2) {
        const foundManager = this.findManagersExistList(value);
        if (foundManager.length > 0) return;
        this.loading = true;
        EmployeeService.findManagersByName(value)
          .then(data => this.foundManagers.push(...data))
          .finally(() => this.loading = false);
      }
    }
  }

  findManagersExistList(value: string): EmployeeSummary[] {
    return this.foundManagers.filter(manager => manager.name.toLocaleLowerCase()
      .includes(value.toLocaleLowerCase()));
  }
}
